import { VOMarker } from "../model/DataStructure.js";

export interface MarkerListOptions {
    container: HTMLElement;
    markers: VOMarker[];
    onSelect: (m: VOMarker) => void;
    onPrev: () => void;
    onNext: () => void;
}

export class MarkerList {

    public onSelect = e5.Signal.create<[VOMarker]>();
    public onNext = e5.Signal.create();
    public onPrev = e5.Signal.create();

    private _element: HTMLDivElement;
    private _items: MarkerListItem[] = [];
    private _marker: VOMarker = null;
    private _list: HTMLElement;

    constructor(options: MarkerListOptions) {

        this._element = document.createElement("div");
        this._element.className = "awi-marker-list";
        this._element.innerHTML = `
        
        <div class="awi-marker-list__container container">
            <div class="awi-marker-list__control awi-marker-list__control--start">
                <button class="awi-marker-list__control-item fal fa-chevron-left" data-action="prev"></button>
            </div>
            <ol class="awi-marker-list__list awi-base__scrollbar-none"></ol>
            <div class="awi-marker-list__control awi-marker-list__control--end">
                <button class="awi-marker-list__control-item fal fa-chevron-right" data-action="next"></button>
            </div>
        </div>
        `;
        this._list = this._element.querySelector(".awi-marker-list__list");

        for (let m of options.markers) {
            this._items.push(
                new MarkerListItem({
                    container: this._list,
                    marker: m
                })
            );
        }

        if (typeof options.onSelect === "function") {
            this.onSelect.add(options.onSelect);
        }

        if (typeof options.onPrev === "function") {
            this.onPrev.add(options.onPrev);
        }

        if (typeof options.onNext === "function") {
            this.onNext.add(options.onNext);
        }

        e5.event.on({
            type: "click",
            scope: this._element,
            selector: ".awi-marker-list__item[data-id]",
            listener: (e) => {
                let id = parseInt(e.target.getAttribute("data-id"));
                let m = e5.array.id(options.markers, id);
                if (m) {
                    this.onSelect.dispatch(m);
                }
            },
        });

        e5.event.on({
            type: "click",
            listener: (e) => {
                this.onPrev.dispatch();
            },
            scope: this._element,
            selector: `[data-action="prev"]`
        });

        e5.event.on({
            type: "click",
            listener: (e) => {
                this.onNext.dispatch();
            },
            scope: this._element,
            selector: `[data-action="next"]`
        });

        this._list.addEventListener("wheel",
            (e) => {

                if(this.isHorizontal()){
                    let sl = e5.Calc.clamp(this._list.scrollLeft + e.deltaY, 0, this._list.scrollWidth - this._list.offsetWidth);
                    if (this._list.scrollLeft != sl) {
                        gsap.to(this._list, {
                            duration: 0.5,
                            scrollLeft: sl
                        });
                    }
                    e.preventDefault();
                }

            }, {
            passive: false
        });

        options.container.appendChild(this._element);
    }

    private isHorizontal():boolean{
        return this._list.scrollWidth > this._list.scrollHeight;
    }

    public get marker(): VOMarker {
        return this._marker;
    }

    public set marker(value: VOMarker) {
        if (this._marker?.id == value?.id) {
            return;
        }

        var m = this.getMarker(this._marker);
        if (m) {
            m.selected = false;
        }

        this._marker = value;


        var m = this.getMarker(this._marker);
        if (m) {
            m.selected = true;
            // m.element.scrollIntoView({
            //     behavior: "smooth"
            // })

            let list = this._list;
            let sl = e5.Calc.clamp((m.element.offsetLeft + m.element.offsetWidth * 0.5) - list.offsetWidth * 0.5, 0, list.scrollWidth - list.offsetWidth);
            if (list.scrollLeft != sl) {
                gsap.to(list, {
                    duration: 0.5,
                    scrollLeft: sl
                });
            }
        }

        // this.visible = Boolean(value);
    }

    private getMarker(m: VOMarker): MarkerListItem {
        if (!m) {
            return null;
        }
        for (let ma of this._items) {
            if (ma.marker.id == m.id) {
                return ma;
            }
        }
        return null;
    }
}

interface MarkerListItemOptions {
    marker: VOMarker;
    container: HTMLElement;
}

class MarkerListItem {

    public readonly element: HTMLElement;

    public readonly marker: VOMarker;

    constructor(options: MarkerListItemOptions) {
        const m = options.marker;
        this.element = document.createElement("li");
        this.element.className = "awi-marker-list__item";
        this.element.setAttribute("data-id", m.id + "");
        this.element.innerHTML = `
        <button class="awi-marker-list__item-button">
            <span class="awi-marker-list__item-index">${(m.index + 1)}</span>
            <span class="awi-marker-list__item-name">${e5.Text.escapeHtml(m.name)}</span>
        </button>
        `;

        this.marker = m;

        options.container.appendChild(this.element);
    }

    public get selected(): boolean {
        return this.element.classList.contains("awi-marker-list__item--selected");
    }

    public set selected(value: boolean) {
        this.element.classList.toggle("awi-marker-list__item--selected", value);
    }
}